import {O, RunInAction} from "web-vcore";
import {LightPlayer} from "../../../Utils/EffectPlayers/LightPlayer.js";
import {store} from "../../index.js";
import {runInAction} from "mobx";
import {ignore} from "mobx-sync";

export enum LIFXConnectionType {
	Auto = 10,
	WebProxy = 20,
	WebDirect = 30,
	LAN = 40,
}

// returned by effect-json function
export type ScreenLight_Frame = {
	color: string;
	repeat_from?: number;
	repeat_count?: number;
};
export type ScreenLight_PromptInfo = {
	screenBrightness: number;
	frameInterval: number;
	framesLoop?: boolean;
	frames: ScreenLight_Frame[];
	// added during finalization
	frames_orig?: ScreenLight_Frame[];
};

export class LightsState {
	@O accessor lifxConnection = LIFXConnectionType.Auto;
	// web
	@O accessor lifx_webToken = "";
	// lan
	@O accessor lifx_ipAddress = "";
	@O accessor lifx_macAddress = "";

	@O accessor kasa_lights = [] as KasaDevice[];

	@O accessor filter = "";

	@O @ignore accessor screenLight_currentPlayer: LightPlayer|n;
	@O @ignore accessor screenLight_currentPromptInfo: ScreenLight_PromptInfo|n;
}
export function ClearScreenLight() {
	//SetFullScreen(false);
	const uiState2 = store.main.engine.lights;
	if (uiState2.screenLight_currentPlayer) {
		//uiState2.screenLight_currentPlayer.playState = "stopped";
		uiState2.screenLight_currentPlayer.Stop();
	}
	RunInAction("ClearScreenLight", ()=>{
		uiState2.screenLight_currentPlayer = null;
		uiState2.screenLight_currentPromptInfo = null;
	});
}

export class KasaDevice {
	constructor(data?: Partial<KasaDevice>) { Object.assign(this, data); }

   name: string;
   deviceId: string;
   host: string; // this is the only one that's actually needed to send commands
   port: number;

	//rawData: Object;
   //isPowered: boolean;
}